import { createContext, useContext } from 'react'
import type { CommonState, CommonStateActionTypes } from './types'

export const initialState: CommonState = {
  mobilePlatformType: 'unknown',
  paymentChildWindow: null,
  finvuScriptStatus: 'loading',
  finvuPhoneNumber: '',
  finvuHandleId: '',
  stagingEnv: '',
  overlayZIndex: 500,
}

export const CommonStateContext = createContext<CommonState | undefined>(
  initialState,
) // will be undefined if there's no parent provider component

export function useCommonState() {
  const context = useContext<CommonState | undefined>(CommonStateContext)

  if (context === undefined) {
    throw new Error(
      'useCommonStateChanger must be used within a useCommonStateChanger Provider',
    )
  }
  return context
}

export const ACTION_TYPES = {
  UPDATE_MOBILE_PLATFORM_TYPE: 'UPDATE_MOBILE_PLATFORM_TYPE',
  SET_PAYMENT_CHILDWINDOW: 'SET_PAYMENT_CHILDWINDOW',
  UPDATE_FINVU_CLIENT_SCRIPT_STATUS: 'UPDATE_FINVU_CLIENT_SCRIPT_STATUS',
  UPDATE_FINVU_PHONE_NUMBER: 'UPDATE_FINVU_PHONE_NUMBER',
  UPDATE_FINVU_HANDLE_ID: 'UPDATE_FINVU_HANDLE_ID',
  UPDATE_STAGING_ENV: 'UPDATE_STAGING_ENV',
  UPDATE_OVERLAY_ZINDEX: 'UPDATE_OVERLAY_ZINDEX',
} as const

export const CommonStateChangerContext = createContext<
  React.Dispatch<CommonStateActionTypes> | undefined
>(undefined)

export function useCommonStateChanger() {
  const context = useContext<
    React.Dispatch<CommonStateActionTypes> | undefined
  >(CommonStateChangerContext)
  if (context === undefined) {
    throw new Error(
      'useCommonStateChanger must be used within a CommonStateChangerContext Provider',
    )
  }
  return context
}
